import React, { useEffect, useState } from 'react'
import { Col, Grid, Image, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import injectStyles from 'react-jss'
import EditIcon from '@material-ui/icons/Edit'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import * as CONST from '../../../../../../Reducers/Ambassador/const'
import StyledIconButton from '../../../../../../Components/Form/StyledIconButton'
import { authorization } from '../../../../../../Module/Auth/Auth'
import { styles } from './style'
import { businessNumberTitle } from './utils'
import CountryWarnings from '../../../Ambasador/Components/CountryWarnings'
import AmbassadorStatusChange from '../../StatusChange/AmbassadorStatusChange'
import { getContractorTypesLabelsByCountryCode } from '../../../../../../Utils/Misc'

const ContactDetailsSection = ({
  ambassador,
  cities,
  handleUserActions,
  isSpyUpdating,
  documents,
  nmbrsDocument,
  isFadeLoading,
  onRefuse,
}) => {
  const history = useHistory()
  const [countryCode, setCountryCode] = useState(null)

  useEffect(() => {
    if (cities.length > 0) {
      let city = cities.find(cities => ambassador.city.id === cities.id)
      setCountryCode(city.country.countryCode)
    }
  }, [cities])
  const canShowContractorType = ['ES', 'DE'].includes(countryCode)

  const getActiveStatusText = ({ status, isVerified }) => {
    const activeStatusText =
      status === CONST.AMBASSADOR_STATUS_KEY.ACTIVE && isVerified ? 'Yes' : 'No'
    return (
      <div>
        <span>
          {activeStatusText} {isVerified ? '' : '. Email is not verified'}
        </span>
      </div>
    )
  }

  const formattedbusinessNumber =
    ambassador.businessNumber &&
    ambassador.businessNumber.replace(/.(?=.{4,}$)/g, '*')

  const isCityManagerAssistant = authorization.isCityManagerAssistant()

  return (
    <AmbassadorSection>
      <Grid fluid>
        <Row>
          <Col style={{ position: 'absolute', right: 20, width: 50 }}>
            {(authorization.isAdmin() || authorization.isCityManager()) && (
              <StyledIconButton
                style={{ float: 'right' }}
                onClick={() =>
                  history.push(history.location.pathname + '/edit')
                }
              >
                <EditIcon />
              </StyledIconButton>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={2} className={'profile-picture-wrapper'}>
            <Image
              src={ambassador.profilePicture}
              className="profile-picture"
            />
            <div className={'contact-details-user-name'}>{`${
              ambassador.firstName
            } ${ambassador.lastName}`}</div>
          </Col>
          <Col xs={9}>
            <Row>
              {ambassador.email && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'spyEmailAddressTitle'}>
                    Email Address
                  </p>
                  <p className="email" cypress_id={'spyEmailAddressField'}>
                    {ambassador.email}
                  </p>
                </Col>
              )}
              {ambassador.mobilePhone && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'spyPhoneTitle'}>
                    Phone number
                  </p>
                  <p cypress_id={'spyPhoneField'}>
                    {ambassador.mobilePhone || '-'}
                  </p>
                </Col>
              )}
              {countryCode !== 'US' && (
                <Col xs={4} className="ambassador-details-col">
                  <p
                    className="col-title"
                    cypress_id={'spyBusinessNumberTitle'}
                  >
                    {businessNumberTitle(countryCode)}
                  </p>
                  <p cypress_id={'spyBusinessNumberField'}>
                    {formattedbusinessNumber || '-'}
                  </p>
                </Col>
              )}
              {ambassador.city && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'spyCityNameTitle'}>
                    City
                  </p>
                  <p cypress_id={'spyCityNameDropdown'}>
                    {ambassador.city.name || '-'}
                  </p>
                </Col>
              )}
              {ambassador.status && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'spyStatusTitle'}>
                    Status
                  </p>
                  <p className="text-capitalize" cypress_id={'spyStatusField'}>
                    {CONST.AMBASSADOR_STATUS_LABEL[ambassador.status] || '-'}
                  </p>
                </Col>
              )}
              {ambassador.status && (
                <Col xs={4} className="ambassador-details-col">
                  <p
                    className="col-title"
                    cypress_id={'isActiveSpyStatusTitle'}
                  >
                    Active
                  </p>
                  <p
                    className="text-capitalize"
                    cypress_id={'isActiveSpyStatusField'}
                  >
                    {getActiveStatusText(ambassador)}
                  </p>
                </Col>
              )}
              {ambassador.paymentDetails && !isCityManagerAssistant ? (
                <React.Fragment>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">Bank Address 1</p>
                    <p className="text-capitalize">
                      {ambassador.paymentDetails.bankAddress1 || '-'}
                    </p>
                  </Col>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">Bank Address 2</p>
                    <p className="text-capitalize">
                      {ambassador.paymentDetails.bankAddress2 || '-'}
                    </p>
                  </Col>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">Bank Post Code</p>
                    <p className="text-capitalize">
                      {ambassador.paymentDetails.bankPostCode || '-'}
                    </p>
                  </Col>
                </React.Fragment>
              ) : null}
              {canShowContractorType ? (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Contractor type</p>
                  <p className="text-capitalize">
                    {
                      getContractorTypesLabelsByCountryCode(countryCode)[
                        ambassador.contractorType
                      ]
                    }
                  </p>
                </Col>
              ) : null}
            </Row>
          </Col>
        </Row>
      </Grid>
      <CountryWarnings country={countryCode} status={status} />

      <AmbassadorStatusChange
        ambassador={ambassador}
        onChange={handleUserActions}
        documents={documents}
        nmbrsDocument={nmbrsDocument}
        disabled={!!ambassador.isLoading || isFadeLoading || isSpyUpdating}
        onRefuse={onRefuse}
      />
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(ContactDetailsSection)
